<template>
  <b-card title="">
    <h3 class="text-primary font-weight-bold mb-2">ข้อมูลผู้ใช้งาน</h3>
    <b-row>
      <b-col md="6">
         <h5 class="h4 font-weight-bold">ชื่อผู้ใช้งาน</h5>
        <b-form-group label="" label-for="username">
          <b-form-input v-model="formUser.username" placeholder="ชื่อผู้ใช้งาน" />
          <!-- <b-form-input id="username" placeholder="ชื่อผู้ใช้งาน" /> -->
        </b-form-group>
      </b-col>
      <b-col md="6">
          <h5 class="h4 font-weight-bold">รหัสผ่าน</h5>
        <b-form-group label="" label-for="password">
          <b-form-input id="login-password" v-model="formUser.password" class="form-control-merge"
            :type="formUser.passwordFieldType" name="login-password" placeholder="รหัสผ่าน" />
          <!-- <b-form-input v-model="formUser.password" placeholder="รหัสผ่าน"  /> -->
        </b-form-group>
      </b-col>

      <b-col md="6">
         <h5 class="h4 font-weight-bold">เลือกสิทธิ์</h5>
        <b-form-group label="" label-for="role">
          <b-form-select v-model="selected" :options="options" />
          <!-- <b-card-text class="mt-1 mb-0">
          เลือกสิทธิ์: <strong>{{ selected }}</strong>
        </b-card-text> -->
        </b-form-group>
      </b-col>
      <b-col md="6"> </b-col>
      <b-col md="6">
          <h5 class="h4 font-weight-bold">ชื่อ</h5>
        <b-form-group label="" label-for="firstname">
          <b-form-input v-model="formUser.firstname" placeholder="ชื่อ" />
        </b-form-group>
      </b-col>
      <b-col md="6">
         <h5 class="h4 font-weight-bold">นามสกุล</h5>
        <b-form-group label="" label-for="lastname">
          <b-form-input v-model="formUser.lastname" placeholder="นามสกุล" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-button variant="primary" type="submit" @click.prevent="validationForm">
        เพิ่มผู้ใช้งาน
      </b-button>
    </b-col>
    <b-col md="6">
      <br />
      <h3 class="text-primary font-weight-bold mb-2">
        ข้อมูลผู้ใช้งาน
      </h3>
    </b-col>
    <b-row>

      <b-col md="6" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="h5 mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                ยกเลิก
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
        <!-- 👇 CUSTOM ACTION COLUMN -->
        <template #cell(action)="props">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="editItem(props.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>แก้ไข</span>
            </b-dropdown-item>
            <b-dropdown-item @click="confirmText(props.item)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>ลบ</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>
    <!-- Pagination -->
    <b-card v-show="true" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, totalRows) }}
          of {{ totalRows }} entries
        </div>
        <!-- {{currentPage}} -->
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="handlePageChange"
            class="mb-0" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="left"
            hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>

    <b-modal id="edit-user-modal" title="แก้ไขข้อมูลผู้ใช้" v-model="showEditModal" @ok="saveUserEdit" ok-title="บันทึก"
      cancel-title="ยกเลิก">
      <b-form-group label="ชื่อ" label-for="firstname">
        <b-form-input v-model="editUser.firstname" id="firstname" />
      </b-form-group>

      <b-form-group label="นามสกุล" label-for="lastname">
        <b-form-input v-model="editUser.lastname" id="lastname" />
      </b-form-group>
      <!-- 
      <b-form-group label="เบอร์โทรศัพท์" label-for="phone">
        <b-form-input v-model="editUser.phone" id="phone" />
      </b-form-group>

      <b-form-group label="อีเมล" label-for="email">
        <b-form-input v-model="editUser.email" id="email" type="email" />
      </b-form-group> -->

      <!-- เพิ่ม fields อื่นตามต้องการ เช่น IdCode, cardType ฯลฯ -->
    </b-modal>
    <div class="demo-inline-spacing">
      <!-- <div>
        <h5>Confirm Button Text</h5>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="confirmText"
        >
          Confirm Text
        </b-button>
      </div> -->
      <!-- <div>
      <h5>Confirm Button Text</h5>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        @click="confirmButtonColor"
      >
        Confirm Button Color
      </b-button>
    </div> -->
    </div>
  </b-card>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "username",
          label: "ชื่อผู้ใช้งาน",
        },
        {
          key: "firstname",
          label: "ชื่อ",
        },
        {
          key: "lastname",
          label: "นามสกุล",
        },
        {
          key: "role",
          label: "สิทธิ์",
        },
        { key: "action", label: "แก้ไข/ลบ" }, // ✅ เพิ่มตรงนี้
      ],
      items: [],
      selected: null,
      options: [
        { value: null, text: "-- เลือกสิทธิ์ --" },
        { value: "admin", text: "admin" },
        { value: "staff", text: "staff" },
           { value: "customer", text: "customer" },
          // { value: "employer", text: "employer (น.จ. , นายจ้าง)" },
      ],
      formUser: {
        username: "",
        password: "",
        passwordFieldType: "password",
        firstname: "",
        lastname: "",
      },
      showEditModal: false,
      editUser: {
        userId: null,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        // ...เพิ่มฟิลด์อื่นตาม backend
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.getDataTable();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editItem(item) {
      this.editUser = { ...item }; // clone item
      this.showEditModal = true;
      // เพิ่ม logic แก้ไข
    },
    async saveUserEdit() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //  console.log(jwt);

      const _data = new FormData();
      _data.append("firstname", this.editUser.firstname);
      _data.append("lastname", this.editUser.lastname);
    //  console.log("editUser", this.editUser.firstname);
     // console.log("editUser", this.editUser.lastname);
    
      try {
        const res = await axios.put(`${API}updateUserDetails/${this.editUser.userId}`, _data,
          {
            headers: {
              Authorization: await store.dispatch("getAuthorization"), // ใช้ refreshToken จาก JWT
            },
          }
        );

        this.$bvToast.toast("บันทึกสำเร็จ", {
          title: "สำเร็จ",
          variant: "success",
          solid: true,
        });
        this.showEditModal = false;
        await this.getDataTable(); // โหลดใหม่
      } catch (err) {
        console.error("❌ บันทึกไม่สำเร็จ:", err);
        this.$bvToast.toast("เกิดข้อผิดพลาดในการบันทึก", {
          title: "ผิดพลาด",
          variant: "danger",
          solid: true,
        });
      }
    },
    deleteItem(item) {
      console.log("Delete:", item);
      confirmText();
      // เพิ่ม logic ลบ
    },
    confirmText(item) {
      console.log(item);

      this.$swal({
        title: "ลบข้อมูล?",
        text: "คุณต้องการจะลบข้อมูล ใช่หรือไม่!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          const refreshToken = localStorage.getItem("refresh_token");
          await axios
            .delete(`${API}deleteUserAccount`, {
              data: {
                userId: item.userId,
              },
              headers: {
                Authorization: refreshToken, //await store.dispatch("getAuthorization"),
              },
            })
            .then(async (el) => {
              console.log(el.data.message);
              if (el.data.message == "Delete Account Complete.") {
                this.$swal({
                  icon: "success",
                  title: "ลบข้อมูล!",
                  text: "ลบข้อมูลสำเร็จ",
                  showCancelButton: false,
                  showConfirmButton: true,
                  timer: 1500,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
              this.getDataTable();
            })
            .catch((err) => {
              if (err.response) {
                console.error("❌ API Error:", err.response.status);
                console.error("Response:", err.response.data);
              } else {
                console.error("❌ Error:", err.message);
              }
            });

          return;
        }
      });
    },

    async getDataTable() {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));

        const params = {
          companyId: jwt.companyId,
          userId: jwt.userId,
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
          role: 'admin',
        };

        const res = await axios.get(`${API}allUserFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        const role = params.role = 'staff'
        const res2 = await axios.get(`${API}allUserFromCompany`, {
          params,
          role,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });


        //  const role3 = params.role = 'employer'
        // const res3 = await axios.get(`${API}allUserFromCompany`, {
        //   params,
        //   role3,
        //   headers: {
        //     Authorization: await store.dispatch("getAuthorization"),
        //   },
        // });

        const combinedUsers = [
          ...(res.data.message[0]?.results || []),
          ...(res2.data.message[0]?.results || []),
            //...(res3.data.message[0]?.results || [])
        ];


       // console.log("รวมทั้งหมด", combinedUsers);


        // if (!res.data.message[0] || !res.data.message[0].total) {
        //   this.items = [];
        //   this.totalRows = 0;
        //   return;
        // }
        // console.log("API Response", res.data.message);
        // console.log("API Response totalRows", res.data.message[0].total);



        // console.log("API Response", xxx)

        this.items = combinedUsers
        this.totalRows = combinedUsers.length
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      console.log(jwt);
      await axios
        .get(
          `${API}allUserFromCompany?companyId=${jwt.companyId}&userId=${jwt.userId}`,
          {
            // headers: {
            //   Authorization: await store.dispatch("getAuthorization"),
            // },
          }
        )
        .then((res) => {
          console.log("✅ success");
          console.log(res.data.message[0]);
          this.items = res.data.message[0].results;
          console.log(this.items);
        })
        .catch((err) => {
          if (err.response) {
            console.error("❌ API Error:", err.response.status);
            console.error("Response:", err.response.data);
          } else {
            console.error("❌ Error:", err.message);
          }
        });



    },
    async validationForm() {
      const { username, password, firstname, lastname } = this.formUser;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
     // console.log(jwt);

      const _data = new FormData();
      _data.append("companyId", jwt.companyId);
      _data.append("username", username);
      _data.append("password", password);
      _data.append("role", this.selected);
      _data.append("firstname", firstname);
      _data.append("lastname", lastname);
      console.log("ddddddddddddd");

      console.log(username);
      console.log(password);
      console.log(this.selected);
      console.log(firstname);
      console.log(lastname);

      axios
        .post(`${API}registerUser`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.message.message == "Registration user is complete.") {
            this.$swal({
              icon: "success",
              title: "บันทึกข้อมูล!",
              text: "บันทึกข้อมูลสำเร็จ",
              showCancelButton: false,
              showConfirmButton: true,
              timer: 1500,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.getDataTable();
          }
        })
        .catch(async (error) => {
          console.log(error.response);
          this.$store.commit("setToastMessage", {
            message: `${error.response.data.message}`,
            title: "ผู้ใช้งาน limit",
            variant: "danger",
          });
        });
    },
    async handlePageChange(page) {
      console.log(page);
      this.currentPage = page;
      this.items = [];

      await this.getDataTable();
    },
    async handleItemsPerPageChange() {
      this.items = [];
      this.currentPage = 1;
      await this.getDataTable();
    },
  },
};
</script>